export function makeBalance(details) {
  return {
    unallocated: details.unallocated
    //For now affiliate stats is not yet part of this feature.
    //We will uncomment this once they have decided to use the affiliate stats graph.
    //acWalletWithdrawable: details.statistics.balances.withdrawable_balance,
    //totalRunningCommission: details.statistics.balances.total_running_commission
  };
}

export function makeOtherDetails(details) {
  return {
      currency: details.currency === 'BTC' ? 'EUR' : details.currency,
      verifiedAt: details.verified_at,
      activatedAt: details.activated_at,
  };
}

export function makeStatistics(details) {
  return {
    referralCount: details.statistics.statistics.referral_count,
    newCustomers: details.statistics.statistics.current_period_new_customers,
    customersWithDeposit: details.statistics.statistics.current_period_customers_with_deposit,
    activeCustomers: details.statistics.statistics.current_period_active_customers
  };
}

class DashboardStore {
  constructor(DashboardApiService, CustomerApiService) {
    'ngInject';

    this.DashboardApiService = DashboardApiService;
    this.CustomerApiService = CustomerApiService;
  }

  getDashboardDetails() {
    return this.DashboardApiService.dashboard().then((details) => {
      return {
        balance: makeBalance(details),
        others: makeOtherDetails(details),
        //statistics: makeStatistics(details),
      };
    });
  }

  getCustomerProducts() {
    return this.CustomerApiService.getProducts();
  }

  getCondition() {
    return this.DashboardApiService.condition();
  }
}

export default DashboardStore;



// WEBPACK FOOTER //
// ./client/app/pages/customer/dashboard/service/dashboard.store.js